module.exports = __webpack_public_path__ + "static/media/ubahn-o-echtzeit~vGjgZLpf.554e4576.svg";